export enum RouteName {
  MY_INSURANCE_PAGES = 'mine-forsikringssider',
  INVOICE_ARCHIVE = '/fakturaarkiv',
  DOCUMENT_ARCHIVE = '/dokumentarkiv',
  CONTACT_US = '/kontakt-oss',
  INSURANCE_DETAILS = '/avtale',
  CORPORATE_INSURANCE_DETAILS = '/avtale-bedrift',
  INSURANCE_LIMITED_DETAILS = '/flere-detaljer',
  CHANGE_INSURANCE = '/endre',
  CANCEL_INSURANCE = '/avslutt',
  RE_REGISTER = '/paregistrer',
  VEHICLE_LOOKUP = '/kjoeretoey',
  CHANGE_ADDRESS = '/endre-adresse',
}
